var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlLegs1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1258,
    viewBox: "0 0 1160 1258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Legs / 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.033 981.41L194.058 932.381L177.027 882.787L74.0004 967.751L143.841 1127.63C143.841 1127.63 150.02 1083.8 149.704 1039.03C149.487 1008.11 145.033 981.41 145.033 981.41ZM737.299 1100.39L726.251 1058.44L675.962 1060.32L715.528 1177.63L872.422 1079.34C825.076 1062.64 737.299 1100.39 737.299 1100.39Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.698 944.877L176.31 882.742L115.922 932.581L145.033 981.411L181.698 944.877ZM717.867 1025.93L666.386 1035.53L695.828 1118.26L737.299 1100.39L717.867 1025.93Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pants color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pants",
    d: "M458.929 743.563C379.011 902.62 241.437 1037.46 241.437 1037.46L118.263 854.807C118.263 854.807 282.359 710.73 359.801 392.578C346.783 340.307 337.532 297.249 334.283 269.653C323.63 179.288 377.378 118.441 391.801 103.922H398.417L560.473 103.922C563.936 116.806 577.667 189.036 572.917 295.439C587.224 342.98 603.974 400.365 623.378 469.249C733.839 861.365 785.07 1034.29 785.07 1034.29L575.072 1109.19C575.072 1109.19 514.793 928.688 458.929 743.563Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Overlay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    opacity: 0.14688,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.07 1034.29L575.072 1109.19C575.072 1109.19 511.993 920.305 455.089 730.807C419.553 612.595 383.435 487.403 359.801 392.576C346.783 340.306 337.532 297.249 334.283 269.653C323.63 179.287 377.378 118.441 391.801 103.922H510.705C520.591 130.633 540.512 187.922 572.918 295.441C587.224 342.98 603.974 400.364 623.378 469.249C733.839 861.364 785.07 1034.29 785.07 1034.29Z",
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlLegs1);
export default __webpack_public_path__ + "static/media/Girl-Legs-1.a849ac55.svg";
export { ForwardRef as ReactComponent };